<div *ngIf="filters$ | async as filters">
  <app-horizontal-filter-list-atom
    [items]="filters"
    (clickItem)="onClickFilter($event)"
  ></app-horizontal-filter-list-atom>
</div>
